import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { SpinnerSmallComponent } from "./helper-components/spinner-small.component";
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AuthService, MessageBrokerService } from './core/index';
import { NoContentComponent, UnAuthorizeComponent, ErrorComponent, SpinnerComponent, NotificationComponent, NotificationsService, LinkTextAreaComponent } from './helper-components/index';
import { GlobalErrorHandler } from './core/error-handler';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalPromptComponent, ModalPromptDialogComponent } from './helper-components/modal-prompt.component';
import { ModalPromptService } from './helper-components/modal-prompt.service';
import { AutoGrowDirective } from './auto-grow.directive';
import { AutoResizeDirective } from './auto-resize.directive';
import { PaginatorComponent } from '../clearance-item/pagination/paginator.component';
import { CarouselComponent } from '../clearance-item/carousel.component';
import { ModalComponent } from './helper-components/modal/_directives';
import { NavigationTrackerService } from './helper-components/navigation-tracker.service';


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  declarations: [
    UnAuthorizeComponent,
    NoContentComponent,
    ErrorComponent,
    SpinnerComponent,
    SpinnerSmallComponent,
    NotificationComponent,
    ModalPromptComponent,
    ModalPromptDialogComponent,
    AutoGrowDirective,
    AutoResizeDirective,
    LinkTextAreaComponent,
    PaginatorComponent,
    CarouselComponent,
    ModalComponent
    
  ],
  exports: [
    UnAuthorizeComponent,
    NoContentComponent,
    ErrorComponent,
    SpinnerComponent,
    SpinnerSmallComponent,
    NotificationComponent,
    BrowserModule,
    ModalPromptComponent,
    AutoGrowDirective,
    AutoResizeDirective,
    LinkTextAreaComponent,
    PaginatorComponent,
    CarouselComponent,
    ModalComponent,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
})
export class SharedModule {

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthService, 
        MessageBrokerService, 
        NotificationsService,
        GlobalErrorHandler,
        ModalPromptService
      ]
    };
  }
}